export const scrollIntoView = (elementId: string) => {
  const element = document.getElementById(elementId);

  if (element !== null && typeof element.scrollIntoView === 'function') {
    requestAnimationFrame(() => element.scrollIntoView({ behavior: 'smooth' }));
  }
};
